import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import "./PaymentStatus.css";

const PaymentCancel = () => {
  const [searchParams] = useSearchParams();
  const productSlug = searchParams.get("product");

  return (
    <main className="payment-status-page">
      <section className="payment-status-card">
        <p className="eyebrow">Checkout Cancelled</p>
        <h1>Your payment was not completed.</h1>
        <p>No charge was made. Your items are safe in your cart and you can complete checkout anytime.</p>
        
        <div className="payment-actions">
          <Link to="/cart">Return to Cart</Link>
          {productSlug && <Link to={`/product/${productSlug}`}>Return to Product</Link>}
          <Link to="/shop">Continue Shopping</Link>
        </div>
      </section>
    </main>
  );
};

export default PaymentCancel;
